import {_request, _requestForm} from "./api";

export const listOfficialRoles = () => _request({ target: 'competition/official-roles' });

export const listOfficialRates = competitionId =>
    _request({ target: `competition/${competitionId}/official-rates` });

export const addOfficialRate = (competitionId, params) =>
    _request({ target: `competition/${competitionId}/official-rates`, method: 'POST', params });

export const editOfficialRate = (competitionId, rateId, params) =>
    _request({ target: `competition/${competitionId}/official-rates/${rateId}`, method: 'PUT', params });

export const removeOfficialRate = (competitionId, rateId) =>
    _request({ target: `competition/${competitionId}/official-rates/${rateId}`, method: 'DELETE' });

export const add = (date) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _request({
            target: 'competition', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (date,competitions_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _request({
            target: `competition/${competitions_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'competition/item', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'competition', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listType = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'competition/type', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listSystemType = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'competition/system-type', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const generateSchedule = competitions_id => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'match/generate-schedule',
            method: 'POST',
            params: { competitions_id }
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
